import { FieldValues, Path, useFormContext } from "react-hook-form";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DropdownFilterEvent } from "primereact/dropdown";

import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useFormDropdownBranchContext } from "./form-dropdown-branch.context";

export interface FormDropdownBranchProps<T extends FieldValues> {
  name: Path<T>;
  allowCreate?: boolean;
}

export function FormDropdownBranch<T extends FieldValues>({
  name,
  allowCreate = false,
}: FormDropdownBranchProps<T>) {
  const hintText = allowCreate
    ? `Select from the created holidayType dropdown. Otherwise, hit ENTER to create a new holidayType. If the holidayType doesn't exist select N/A`
    : "";
  const { control } = useFormContext<T>();
  const {
    sidebar,
    newBranch,
    mappedBranch,
    isCreating,
    setSidebar,
    setFilter,
    setNewBranch,
    handleFilterInput,
    handleAdd,
  } = useFormDropdownBranchContext();
  
  return (
    <div className="branch">
      {newBranch && (
        <Sidebar visible={sidebar} onHide={() => setSidebar(false)}>
          <h2>Create new branch</h2>
          <p>
            You are creating a new branch. Please, fill the fields to create a
            new branch and apply to current item creation.
          </p>
          <div className="flex flex-col gap-2 mt-4">
            <InputText
              placeholder="Branch Name"
              value={newBranch.name}
              onChange={(e: any) =>
                setNewBranch({ ...newBranch, name: e.target.value })
              }
            />
            <InputText
              placeholder="Branch Description"
              value={newBranch.description}
              onChange={(e: any) =>
                setNewBranch({ ...newBranch, description: e.target.value })
              }
            />

            <Button
              label="Create"
              onClick={handleAdd}
              className="block"
              disabled={isCreating}
            />
          </div>
        </Sidebar>
      )}
      <DropdownControl<T>
        control={control}
        name={name}
        label="Branch"
        options={ mappedBranch }
        containerClassName="mb-9"
        className="w-full md:w-3/4"
        placeholder="Enter your branch"
        hint={hintText}
        filter
        onFilter={(e: DropdownFilterEvent) => setFilter(e.filter)}
        onKeyDown={allowCreate ? handleFilterInput : () => {}}
      />
    </div>
  );
}

export default FormDropdownBranch;